/**
 * Layer 2 — Device Intelligence (client side).
 *
 * A best-effort, stable per-browser fingerprint. It is NOT a security control on
 * its own — the server treats it as a hint and always has its own server-side
 * fallback — but sending a real, stable value (instead of the empty string the
 * app used to send) is what lets the server's device trust profile, blacklist
 * and velocity rules actually match a device.
 */

const DEVICE_KEY = 'ap_device_fp';

/** Cheap canvas + environment hash, mixed with a persisted random salt. */
function computeFingerprint() {
    let salt = '';
    try {
        salt = localStorage.getItem(DEVICE_KEY + '_salt') || '';
        if (!salt) {
            salt = Math.random().toString(36).slice(2) + Date.now().toString(36);
            localStorage.setItem(DEVICE_KEY + '_salt', salt);
        }
    } catch (_) {
        salt = Math.random().toString(36).slice(2);
    }

    const parts = [
        navigator.userAgent || '',
        navigator.language || '',
        (navigator.languages || []).join(','),
        screen.width + 'x' + screen.height + 'x' + (screen.colorDepth || ''),
        new Date().getTimezoneOffset(),
        navigator.hardwareConcurrency || '',
        navigator.deviceMemory || '',
        salt,
    ];

    try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.textBaseline = 'top';
            ctx.font = "14px 'Arial'";
            ctx.fillStyle = '#f60';
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = '#069';
            ctx.fillText('apsession-fp', 2, 15);
            parts.push(canvas.toDataURL());
        }
    } catch (_) {
        /* canvas blocked — fall back to the env parts only */
    }

    // djb2-ish string hash -> hex, prefixed so it's obviously a client fp.
    const str = parts.join('|');
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    }
    return 'fp_' + h.toString(16) + salt.slice(0, 8);
}

/** A stable device fingerprint, persisted in localStorage. */
export function getDeviceFingerprint() {
    try {
        const cached = localStorage.getItem(DEVICE_KEY);
        if (cached) return cached;
        const fp = computeFingerprint();
        localStorage.setItem(DEVICE_KEY, fp);
        return fp;
    } catch (_) {
        // Storage blocked (private mode / cookies off): recompute each call.
        return computeFingerprint();
    }
}
